import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    const api = await getAxiosInstance();
    const getParams = (key) => {
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };

    try {
      const response = await api[method](
        `${endpoint}?${getParams("start_date")}${getParams(
          "end_date"
        )}${getParams("filter")}${getParams("sort_by")}is_active=${
          params?.is_active ? params["is_active"] : 0
        }&sort_order=${params?.sort_order || "desc"}&page_size=${
          params?.per_page || "10"
        }&${getParams("search")}page=${params?.page || 1}`,
        body
      );

      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err?.response?.data || err.message,
      };
    }
  };

export const currency = createApi({
  reducerPath: "currencyApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["currency"],
  endpoints: (builder) => ({
    getCurrencyListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `admin/currencies`,
      }),
      providesTags: ["currency"],
    }),
    updateTableFieldsData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `admin/user/fields/update`,
      }),

      invalidatesTags: ["currency"],
    }),
    updateCurrencyStatus: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/admin/currencies/change/status`,
      }),
      // invalidatesTags:["currency"]
    }),

    getCurrencyData: builder.query({
      query: () => ({
        method: "get",
        endpoint: `/admin/master/currency`,
      }),
      providesTags: ["currency"],
    }),
  }),
});

export const {
  useGetCurrencyListDataQuery,
  useUpdateTableFieldsDataMutation,
  useUpdateCurrencyStatusMutation,
  useGetCurrencyDataQuery,
} = currency;
